import React, { useEffect, useState } from 'react';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import * as app_consts from "../../../utils/app_consts";
import { useDispatch, useSelector } from 'react-redux';
import { TENANT_RETRIEVE_PROMOTION_RESTRICTED_NUMBERS_SETTINGS_API, TENANT_ADD_PROMOTION_RESTRICTED_NUMBERS_SETTINGS_API, TENANT_DELETE_PROMOTION_RESTRICTED_NUMBERS_SETTINGS_API } from '../../../api/api_data';
import { DELETE_RESTRICTED_NUMBER_ERROR_MSG, DELETE_RESTRICTED_NUMBER_SUCCESS_MSG, RETRIVE_SETTINGS_DETAILS_ERROR_MSG, RETRIVE_SETTINGS_DETAILS_SUCCESS_MSG, UPDATE_SETTINGS_DETAILS_ERROR_MSG, UPDATE_SETTINGS_DETAILS_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_tenant_promotions_restricted_numbers_settings, loading_retrieve_tenant_promotions_restricted_numbers_settings, success_retrieve_tenant_promotions_restricted_numbers_settings } from '../../../reducers/auth_tenant/retrieve_tenant_promotions_restricted_numbers_settings_Slice';
import { messageToast } from '../../../utils/Utils';
import { reset_retrieve_tenant_promotions_restricted_numbers_settings } from '../../../reducers/auth_tenant/retrieve_tenant_promotions_restricted_numbers_settings_Slice';
import { Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, Row } from '../../Component';
import TextInput from '../../../pages/components/inputs/TextInput';
import PhoneInput from 'react-phone-input-2';
import { fail_tenant_add_restricted_number_settings, loading_tenant_add_restricted_number_settings, reset_tenant_add_restricted_number_settings, success_tenant_add_restricted_number_settings } from '../../../reducers/auth_tenant/tenant_add_restricted_number_settings_Slice';
import YesNoModal from '../YesNoModal';
import { fail_tenant_delete_restricted_number_settings, loading_tenant_delete_restricted_number_settings, reset_tenant_delete_restricted_number_settings, success_tenant_delete_restricted_number_settings } from '../../../reducers/auth_tenant/tenant_delete_restricted_number_settings_Slice';

const initial_state = { promotion_id: '', name: "", mobile_number: "", reason: "" };

const ViewRestrictedNumbersPromotionsDetailsModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction, data }) => {

  const [page_data, setPageData] = useState([]);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [form_data, setFormData] = useState(initial_state);
  const [update_loading, setUpdateLoading] = useState(false);
  const [update_error, setUpdateError] = useState("");
  const [sent_data, setSentData] = useState(data);
  const [delete_modal, setDeleteModal] = useState(false);
  const [selected_delete, setSelectedDelete] = useState("");
  const [delete_error, setDeleteError] = useState("");

  useEffect(() => {
    if (isOpen && data)
    {
      // Dispatch
      setEditMode(false);
      retrieve_data(data);
      setSentData(data);
      setUpdateError('');
      setError("");
    }
    setOpen(isOpen);
  }, [isOpen, data]);

  const retrieve_data = (id) => {
    setError('');
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_promotions_restricted_numbers_settings, success_retrieve_tenant_promotions_restricted_numbers_settings, fail_retrieve_tenant_promotions_restricted_numbers_settings, RETRIVE_SETTINGS_DETAILS_ERROR_MSG, RETRIVE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTION_RESTRICTED_NUMBERS_SETTINGS_API}/${id}`));
  };

  // Listener
  const retrieve_tenant_promotions_restricted_numbers_settings_listener = useSelector((state) => state.retrieve_tenant_promotions_restricted_numbers_settings.retrieve_tenant_promotions_restricted_numbers_settings);

  useEffect(() => {
    if (retrieve_tenant_promotions_restricted_numbers_settings_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_promotions_restricted_numbers_settings_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_tenant_promotions_restricted_numbers_settings_listener.status === app_consts.FAIL)
        {
          setError(retrieve_tenant_promotions_restricted_numbers_settings_listener.message);
          messageToast(retrieve_tenant_promotions_restricted_numbers_settings_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_promotions_restricted_numbers_settings_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_promotions_restricted_numbers_settings_listener.data);
        }
        setLoading(false);
        dispatch(reset_retrieve_tenant_promotions_restricted_numbers_settings());
      }
    }
  }, [retrieve_tenant_promotions_restricted_numbers_settings_listener]);

  const handle_add_restricted_number = () => {
    setUpdateError('');
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_tenant_add_restricted_number_settings, success_tenant_add_restricted_number_settings, fail_tenant_add_restricted_number_settings, UPDATE_SETTINGS_DETAILS_ERROR_MSG, UPDATE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_ADD_PROMOTION_RESTRICTED_NUMBERS_SETTINGS_API}`, { ...form_data, promotion_id: sent_data }));
  };

  // Listener
  const tenant_add_restricted_number_settings_listener = useSelector((state) => state.tenant_add_restricted_number_settings.tenant_add_restricted_number_settings);

  useEffect(() => {
    if (tenant_add_restricted_number_settings_listener.status !== app_consts.IDLE)
    {
      if (tenant_add_restricted_number_settings_listener.status === app_consts.LOADING)
      {
        setUpdateLoading(true);
        setUpdateError("");
      } else
      {
        setUpdateLoading(false);
        if (tenant_add_restricted_number_settings_listener.status === app_consts.FAIL)
        {
          setUpdateError(tenant_add_restricted_number_settings_listener.message);
          messageToast(tenant_add_restricted_number_settings_listener.message, app_consts.FAIL);
        } else if (tenant_add_restricted_number_settings_listener.status === app_consts.SUCCESS)
        {
          messageToast(UPDATE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          retrieve_data(sent_data);
          setEditMode(false);
        }
        dispatch(reset_tenant_add_restricted_number_settings());
      }
    }
  }, [tenant_add_restricted_number_settings_listener]);

  // Handle Change Function
  const handleChange = (e) => {
    setFormData({ ...form_data, [e.target.name]: e.target.value });
  };

  const open_delete_modal = (delete_item) => {
    setDeleteModal(true);
    setSelectedDelete(delete_item);
  };

  const close_delete_modal = () => {
    setDeleteModal(false);
    setSelectedDelete("");
  };

  const handle_delete_restricted_number = () => {
    setDeleteError("");
    dispatch(tenant_auth_actions_helper(loading_tenant_delete_restricted_number_settings, success_tenant_delete_restricted_number_settings, fail_tenant_delete_restricted_number_settings, DELETE_RESTRICTED_NUMBER_ERROR_MSG, DELETE_RESTRICTED_NUMBER_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_DELETE_PROMOTION_RESTRICTED_NUMBERS_SETTINGS_API}`, { promotion_id: sent_data, mobile_number: selected_delete?.mobile_number }));
  };

  // Listener
  const tenant_delete_restricted_number_settings_listener = useSelector((state) => state.tenant_delete_restricted_number_settings.tenant_delete_restricted_number_settings);

  useEffect(() => {
    if (tenant_delete_restricted_number_settings_listener.status !== app_consts.IDLE)
    {
      if (tenant_delete_restricted_number_settings_listener.status === app_consts.LOADING)
      {
        setDeleteError("");
      } else
      {
        if (tenant_delete_restricted_number_settings_listener.status === app_consts.FAIL)
        {
          setDeleteError(tenant_delete_restricted_number_settings_listener.message);
          messageToast(tenant_delete_restricted_number_settings_listener.message, app_consts.FAIL);
        } else if (tenant_delete_restricted_number_settings_listener.status === app_consts.SUCCESS)
        {
          messageToast(DELETE_RESTRICTED_NUMBER_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          retrieve_data(sent_data);
          setEditMode(false);
          setDeleteModal(false);
          setSelectedDelete('');
        }
        dispatch(reset_tenant_delete_restricted_number_settings());
      }
    }
  }, [tenant_delete_restricted_number_settings_listener]);

  return (
    <>
      <Modal isOpen={open} toggle={loading ? "" : closeModal} className="modal-dialog-centered" size={"xl"}>
        <ModalHeader toggle={loading ? "" : closeModal}>Restricted Numbers Settings</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>Retrieving Restricted Numbers Settings...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <div className='mt-4'>
                      </div>
                      {
                        editMode && (
                          <>{
                            update_error && (
                              <div className="mb-3 w-100">
                                <Alert color="danger" className="alert-icon">
                                  <Icon name="alert-circle" /> {update_error}{" "}
                                </Alert>
                              </div>
                            )}
                            <Row>
                              <div className="nk-tb-list is-separate is-medium mb-3">
                                <DataTableHead className="nk-tb-item">
                                  <DataTableRow size="lg"><span className="sub-text">Name</span></DataTableRow>
                                  <DataTableRow size="lg"><span className="sub-text">Number</span></DataTableRow>
                                  <DataTableRow size="lg"><span className="sub-text">Reason (30 Characters)</span></DataTableRow>
                                </DataTableHead>
                                <DataTableItem>
                                  <DataTableRow>
                                    <Row className="g-4">
                                      <TextInput
                                        required
                                        type="text"
                                        value={form_data?.name}
                                        colSize="12"
                                        handleChange={handleChange}
                                        name="name"
                                      />
                                    </Row>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <Row className="g-4">
                                      <div className="form-control-wrap">
                                        <PhoneInput
                                          country={"zm"}
                                          value={form_data?.mobile_number}
                                          onChange={(phone) => setFormData({ ...form_data, mobile_number: phone })}
                                          copyNumbersOnly={false}
                                          inputStyle={{ width: '100%' }}
                                        />
                                      </div>
                                    </Row>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <Row className="g-4">
                                      <TextInput
                                        required
                                        type="text"
                                        value={form_data?.reason}
                                        colSize="12"
                                        handleChange={handleChange}
                                        maxlength={30}
                                        name="reason"
                                      />
                                    </Row>
                                  </DataTableRow>
                                </DataTableItem>
                              </div>
                              <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                <Button className='mx-2' onClick={() => { setEditMode(false); setFormData(initial_state); }} disabled={update_loading} color="gray">
                                  Cancel
                                </Button>
                                <Button onClick={handle_add_restricted_number} disabled={
                                  (update_loading) ||
                                  !(form_data?.reason && form_data?.name && form_data?.mobile_number)
                                } color="primary">
                                  {update_loading ? <Spinner size="sm" color="light" /> : "Add Number"}
                                </Button>
                              </Col>
                            </Row>
                            <div className='mb-4'>
                            </div>
                          </>
                        )
                      }
                      {
                        page_data?.restricted_numbers_settings && page_data?.restricted_numbers_settings?.length > 0 ?
                          <>
                            {
                              !editMode && (
                                <>
                                  <div className="m-auto d-flex flex-row justify-content-start align-center my-4" >
                                    <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData({ initial_state }); }} color="primary" size="sm">
                                      Add Number
                                    </Button>
                                  </div>
                                </>
                              )
                            }
                            <Row>
                              <div className="nk-tb-list is-separate is-medium mb-3">
                                <DataTableHead className="nk-tb-item">
                                  <DataTableRow size="lg"><span className="sub-text">Name</span></DataTableRow>
                                  <DataTableRow size="lg"><span className="sub-text">Number</span></DataTableRow>
                                  <DataTableRow size="lg"><span className="sub-text">Reason (30 Characters)</span></DataTableRow>
                                  <DataTableRow size="lg"><span className="sub-text">Delete</span></DataTableRow>
                                </DataTableHead>
                                {
                                  page_data?.restricted_numbers_settings?.map((item) => {
                                    return (
                                      <>
                                        <DataTableItem>
                                          <DataTableRow><span className="tb-lead">{item?.name || "--"}</span></DataTableRow>
                                          <DataTableRow><span className="tb-lead">{item?.mobile_number || "--"}</span></DataTableRow>
                                          <DataTableRow><span className="tb-lead">{item?.reason || "--"}</span></DataTableRow>
                                          <DataTableRow>
                                            <Icon name="trash-fill" className="text-danger" style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => open_delete_modal(item)}></Icon>
                                          </DataTableRow>
                                        </DataTableItem>
                                      </>
                                    );
                                  })
                                }
                              </div>
                            </Row>


                            <YesNoModal openModal={delete_modal} setOpenModal={setDeleteModal} modalTitle={`Remove ${selected_delete?.mobile_number} (${selected_delete?.name}) ?`} errAmend={delete_error} setErrAmend={setDeleteError} buttonCancel="No" buttonConfirm="Yes" modalDescription={`Are you Sure that you want to Delete ${selected_delete?.mobile_number} (${selected_delete?.name}) from Restricted Numbers?`} succFunc={handle_delete_restricted_number} />
                          </>
                          :
                          <>
                            <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                              <div className="text-soft fw-bold my-4" style={{ fontSize: 18 }}>No restricted Numbers Found</div>
                              {
                                !editMode && (
                                  <>
                                    <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData(initial_state); }} color="primary" size="sm">
                                      Add Number
                                    </Button>
                                  </>
                                )
                              }
                            </div>
                          </>
                      }
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewRestrictedNumbersPromotionsDetailsModal;